function createShareLinks() {
  let links = document.querySelectorAll('.facebook-link');

  for (let i = 0; i < links.length; i++) {
    if (links[i].getAttribute('facebook-link-registered') != 'true') {
      links[i].onclick = function() {
        let url = this.getAttribute('data-href');
        FB.ui({
          method: 'share',
          display: 'popup',
          href: url,
        }, function(response){});
      }
      links[i].setAttribute('facebook-link-registered', 'true');
    }
  }
}

module.exports = {
  createShareLinks
}



// WEBPACK FOOTER //
// ./src/js/facebook.js